import React from 'react'
import { useFormatMessage } from '@babylon/intl'
import { envVar } from '@babylon/babylon-env'

import styles from '../styles.module.scss'
import messages from '../Chats.messages'
import CopyButton from './CopyButton'

interface ChatIdCellProps {
  chatId: string
}

const ChatIdCell = ({ chatId }: ChatIdCellProps) => {
  const fm = useFormatMessage()
  const sendbirdProjectId = envVar('SENDBIRD_APPLICATION_ID')

  return (
    <div className={styles.chatIdCell}>
      {sendbirdProjectId ? (
        <a
          href={`https://dashboard.sendbird.com/${encodeURIComponent(
            sendbirdProjectId
          )}/group-channels/${encodeURIComponent(chatId)}`}
          target="_blank"
          rel="noopener noreferrer"
          className={`${styles.profileLink} ${styles.chatIdText}`}
          onClick={(e) => e.stopPropagation()}
        >
          {chatId}
        </a>
      ) : (
        <span className={styles.chatIdText}>{chatId}</span>
      )}
      <CopyButton text={chatId} label={fm(messages.copy_chat_id)} />
    </div>
  )
}

export default ChatIdCell
